import React, { useRef, useState, useEffect } from 'react';
import { useLanguage } from '../../../context/LanguageContext';
import { useNavigate, useLocation } from 'react-router-dom';
import { identifyPlantByImage } from '../../../api/api_plants';

function ScannPlant() {
  const { translations } = useLanguage();
  const [image, setImage] = useState(null);
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [cameraActive, setCameraActive] = useState(true);
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const pot = location.state?.pot || JSON.parse(localStorage.getItem('selectedPot')) || null;

  useEffect(() => {
    if (pot) {
      localStorage.setItem('selectedPot', JSON.stringify(pot));
    }
    async function enableCamera() {
      if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        const stream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: 'environment' } });
        videoRef.current.srcObject = stream;
        videoRef.current.play();
      }
    }
    if (cameraActive) {
      enableCamera();
    }
    return () => {
      if (videoRef.current && videoRef.current.srcObject) {
        videoRef.current.srcObject.getTracks().forEach(track => track.stop());
      }
    };
  }, [pot, cameraActive]);

  const handleBack = () => {
    navigate(-1);
  };

  const handleTakePicture = () => {
    const video = videoRef.current;
    const canvas = canvasRef.current;
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
    if (video.srcObject) {
      video.srcObject.getTracks().forEach(track => track.stop());
      setCameraActive(false);
    }
    canvas.toBlob(async (blob) => {
      setImage(URL.createObjectURL(blob));
      setLoading(true);
      const apiResult = await identifyPlantByImage(new File([blob], "photo.jpg", { type: "image/jpeg" }));
      setResult(apiResult.error ? { error: true, message: apiResult.message } : apiResult.data);
      setLoading(false);
    }, 'image/jpeg');
  };

  return (
    <div className="plant-page">
      <div className="sm-container">
        <div className="header">
          <button onClick={handleBack} className="back-button">&#8592;</button>
          <h1>{translations.plant_scanner}</h1>
        </div>
        <div className="content">
          {image ? (
            <img className="plant-image" src={image} alt="Taken Plant" />
          ) : (
            <video ref={videoRef} className="plant-video" />
          )}
          <canvas ref={canvasRef} className="plant-canvas" />
        </div>
        <div className="content">
          {!result && (
            <button
              onClick={handleTakePicture}
              className="general-button secondary-button"
              disabled={loading || !!image}
            >
              {translations.take_picture}
            </button>
          )}
          {loading && <p>{translations.loading || 'Analyzing...'}</p>}
          {result && (
            <div className="result">
              {result.error ? (
                <p className="general-error">
                  {result.message && result.message.includes('Species not found')
                    ? 'No matching plants found.'
                    : result.message || 'Error identifying plant.'}
                </p>
              ) : (
                <>
                  <h2>Results:</h2>
                  {result.results && result.results.length > 0 ? (
                    <ul className="plant-ul">
                      {result.results.map((res, i) => (
                        <li key={i}>
                          <button
                            className="general-button plant-result-button"
                            onClick={() => {
                              navigate('/plants/addToPot', {
                                state: {
                                  pot: pot,
                                  scannedPlantName: res.scientific_name
                                }
                              });
                            }}
                          >
                            <b>{res.scientific_name}</b>
                            <br />
                            {res.common_name}
                          </button>
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <p className="general-error">No matching plants found.</p>
                  )}
                </>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default ScannPlant;
